import { defineComponent, onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue';
import * as Highcharts from 'highcharts';
import * as Highstock from 'highcharts/highstock';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
export default defineComponent({
    name: 'GraphChart',
    components: {},
    props: {
        options: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            default: 'General',
        },
    },
    setup(props) {
        const chart = ref(null);
        const state = reactive({
            instance: null,
        });
        NoDataToDisplay(Highstock);
        function drawData(options) {
            if (!options.chart || !chart.value)
                return;
            options.chart.renderTo = chart.value;
            options.chart.backgroundColor = 'transparent';
            state.instance = props.type === 'Appliance' ? Highcharts.chart(options) : Highstock.stockChart(options);
        }
        watch(() => props.options, (options) => {
            drawData(options);
        });
        onMounted(() => {
            drawData(props.options);
        });
        onBeforeUnmount(() => {
            state.instance?.destroy();
        });
        return { chart };
    },
});
